import { createPageSegmentLoadMetric } from '@confluence/browser-metrics/entry-points/metricConfigs.ts';
import { IN_EDITOR_TEMPLATES_SEGMENT_KEY } from '@confluence/browser-metrics/entry-points/metric-keys.ts';

export const IN_EDITOR_TEMPLATES_METRIC = createPageSegmentLoadMetric({
	key: IN_EDITOR_TEMPLATES_SEGMENT_KEY,
});
